import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {},
    challenge: null,
    tracking: null,
    baseEccoUrl: process.env.VUE_APP_BASE_ECCO_URL,
    baseUrl: process.env.VUE_APP_BASE_URL,
    state: '39fh03fhj30gh0jfowej0fifjasodin0jhkg2',
    clientId: process.env.VUE_APP_CLIENT_ID,
    redirectUri: process.env.VUE_APP_REDIRECT_URI,
    marianaTekUri: process.env.VUE_APP_MARIANA_TEK_URI,
    marianaBaseUri: process.env.VUE_APP_BASE_MARIANA_URI,
    code: null,
    locations: [],
    locationsLoading: false,
    signupError: null,
    timer: 0,
    timerDisplay: 0,
  },

  mutations: {
    setUser: (state, val) => {
      state.user = val
    },
    setLocations: (state, val) => {
      state.locations = val
    },
    setLocationsLoading: (state, val) => {
      state.locationsLoading = val
    },
    setSignupError: (state, val) => {
      state.signupError = val
    }
  },

  actions: {
    createAccount: ({ commit, state }, data) => {
      axios.post(`${state.baseUrl}/me/account`, data).then((res) => {
        commit('setUser', res.data)
      }).catch((err) => {
        console.log(err.response)
        if (err.response.data?.email?.length > 0) {
          commit('setSignupError', err.response.data.email[0])
        }
      })
    },

    getLocations: ({ commit, state }) => {
      commit('setLocationsLoading', true)
      axios.get(`${state.baseEccoUrl}/mariana/location`).then((res) => {
        commit('setLocations', res.data.data)
        commit('setLocationsLoading', false)
      }).catch((err) => {
        console.log(err.response)
        commit('setLocationsLoading', false)
      })
    },

    resetTimerStart: ({ state }) => {
      state.timer = 0
      const interval = setInterval(() => {
        state.timer += 1
        state.timerDisplay = state.timer
        if (state.timer >= 100) {
          clearInterval(interval)
          location.reload()
        }
      }, 100)
    }
  },

  getters: {
    locationsLoading(state) {
      return state.locationsLoading
    },
  },

  modules: {
  },

  plugins: [],
})